var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAgillicLogo = function SvgAgillicLogo(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 58,
    viewBox: "0 0 135 58",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.561 46.4363C115.477 46.4363 108.896 39.8556 108.896 31.7714C108.896 23.6871 115.477 17.1064 123.561 17.1064C127.433 17.1064 131.007 18.5791 133.89 21.3597C135.157 22.5852 134.982 24.8714 133.973 25.8704C132.747 27.1371 130.924 27.065 129.462 25.9528C128.175 24.9744 126.331 23.4915 123.571 23.4915C119.009 23.4915 115.291 27.2092 115.291 31.7714C115.291 36.3336 119.009 40.0513 123.571 40.0513C126.342 40.0513 128.339 38.3418 129.472 37.5797C131.079 36.4984 132.799 36.4881 133.983 37.796C135.167 39.1039 135.075 41.1223 133.767 42.3067C130.821 44.9739 127.207 46.4363 123.561 46.4363Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.04 13.2703C99.9911 13.2703 98.333 11.6123 98.333 9.5629C98.333 7.51351 99.9911 5.85547 102.04 5.85547C104.09 5.85547 105.748 7.51351 105.748 9.5629C105.748 11.6123 104.09 13.2703 102.04 13.2703Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.043 46.3549C100.292 46.3549 98.8501 44.9234 98.8501 43.1624V20.2999C98.8501 18.5389 100.292 17.1074 102.043 17.1074C103.793 17.1074 105.235 18.5389 105.235 20.2999V43.1624C105.235 44.9234 103.793 46.3549 102.043 46.3549Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.308 46.3428C89.5573 46.3428 88.1155 44.9114 88.1155 43.1503V3.19251C88.1155 1.43148 89.5573 0 91.308 0C93.0587 0 94.5005 1.43148 94.5005 3.19251V43.1503C94.5005 44.9114 93.0587 46.3428 91.308 46.3428Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.631 46.3428C78.8803 46.3428 77.4385 44.9114 77.4385 43.1503V3.19251C77.4385 1.43148 78.8803 0 80.631 0C82.3817 0 83.8235 1.43148 83.8235 3.19251V43.1503C83.8235 44.9114 82.3817 46.3428 80.631 46.3428Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0886 43.1624V20.2999C73.0886 18.5389 71.6469 17.1074 69.8961 17.1074C68.1454 17.1074 66.7036 18.5389 66.7036 20.2999V43.1624C66.7036 44.9234 68.1248 46.3549 69.8961 46.3549C71.6777 46.3549 73.0886 44.9234 73.0886 43.1624Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8944 13.2703C67.8451 13.2703 66.187 11.6123 66.187 9.5629C66.187 7.51351 67.8451 5.85547 69.8944 5.85547C71.9438 5.85547 73.6019 7.51351 73.6019 9.5629C73.6019 11.6123 71.9438 13.2703 69.8944 13.2703Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6105 17.1064C39.5468 17.1064 33.0073 23.6459 33.0073 31.7096C33.0073 39.7732 39.5468 46.3127 47.6105 46.3127C55.6741 46.3127 62.2136 39.7732 62.2136 31.7096C62.2136 23.6459 55.6741 17.1064 47.6105 17.1064ZM47.6105 39.9483C43.0586 39.9483 39.3717 36.2615 39.3717 31.7096C39.3717 27.1577 43.0586 23.4709 47.6105 23.4709C52.1624 23.4709 55.8492 27.1577 55.8492 31.7096C55.8492 36.2615 52.1624 39.9483 47.6105 39.9483Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1919 17.1064C57.4308 17.1064 55.9994 18.5379 55.9994 20.299C55.9994 20.299 55.9994 43.3262 55.9994 43.4601C55.9994 47.8575 52.1477 51.5546 47.6473 51.4928C45.4229 51.4619 43.4971 50.463 41.9626 49.083C40.2325 47.5485 38.3685 48.012 37.3077 49.1242C36.247 50.2467 36.3294 52.327 37.524 53.6349C40.1192 56.4773 43.631 57.8573 47.7812 57.8573C55.8758 57.8573 62.4359 51.2766 62.3844 43.1717C62.3844 43.1614 62.3844 43.1614 62.3844 43.1511V20.299C62.3844 18.5379 60.9529 17.1064 59.1919 17.1064Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6031 17.1641C6.53949 17.1641 0 23.6933 0 31.7672C0 39.8309 6.53949 46.3704 14.6031 46.3704C22.6668 46.3704 29.2063 39.8309 29.2063 31.7672C29.2166 23.6933 22.6771 17.1641 14.6031 17.1641ZM14.6031 40.0059C10.0512 40.0059 6.36442 36.3191 6.36442 31.7672C6.36442 27.2153 10.0512 23.5285 14.6031 23.5285C19.155 23.5285 22.8419 27.2153 22.8419 31.7672C22.8419 36.3191 19.155 40.0059 14.6031 40.0059Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1542 46.4106C24.4034 46.4106 22.9617 44.9791 22.9617 43.2181V20.3556C22.9617 18.5946 24.4034 17.1631 26.1542 17.1631C27.9049 17.1631 29.3467 18.5946 29.3467 20.3556V43.2181C29.3467 44.9791 27.9049 46.4106 26.1542 46.4106Z",
    fill: "url(#paint10_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 114.745,
    y1: 17.0961,
    x2: 132.77,
    y2: 27.3843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#FF5762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC855F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 99.9293,
    y1: 5.85547,
    x2: 102.04,
    y2: 13.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AB0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A362F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 98.8722,
    y1: 46.3768,
    x2: 98.8722,
    y2: 17.1127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#EF597B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A25FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 88.1155,
    y1: 46.3252,
    x2: 88.1155,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0916505,
    stopColor: "#FF5762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682588,
    stopColor: "#A25FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 77.4385,
    y1: 46.3252,
    x2: 77.4385,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0916505,
    stopColor: "#FF5762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682588,
    stopColor: "#A25FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 66.7257,
    y1: 46.3768,
    x2: 66.7257,
    y2: 17.1127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#EF597B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A25FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 67.7833,
    y1: 5.85547,
    x2: 69.8944,
    y2: 13.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AB0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A362F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 39.5983,
    y1: 17.0961,
    x2: 58.601,
    y2: 29.3703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#FF5762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC855F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 49.4405,
    y1: 17.1002,
    x2: 55.7083,
    y2: 56.5239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781677,
    stopColor: "#FF5762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC855F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 6.59098,
    y1: 17.1538,
    x2: 25.5937,
    y2: 29.4279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#FF5762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC855F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 22.9837,
    y1: 46.4325,
    x2: 22.9837,
    y2: 17.1684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#EF597B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A25FFC"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgillicLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agillic_logo.455529cb.svg";
export { ForwardRef as ReactComponent };